import { createAsyncThunk } from '@reduxjs/toolkit';
import MissionRequestFilters from '../../models/service/stats/mission-request-filters';
import HttpError from '@common/interfaces/api/http-error';
import generalDataService from '../../services/data/general-data-service';
import { returnAxiosOrGeneralFetchError } from '../../services/data/axios-base';
import { StatsMissionResponse } from '../../models/service/stats/mission-set';
import Announcement from '../../models/service/announcements/announcement';

export const getStatsMissionEntries = createAsyncThunk<
  StatsMissionResponse,
  MissionRequestFilters,
  { rejectValue: HttpError }
>('service/stats/missions', async (requestFilters, { rejectWithValue }) => {
  try {
    return await generalDataService.getStatsMissionEntries(requestFilters);
  } catch (error) {
    return rejectWithValue(returnAxiosOrGeneralFetchError(error));
  }
});

export const getAnnouncements = createAsyncThunk<Announcement[], void, { rejectValue: HttpError }>(
  'announcements',
  async (_, { rejectWithValue }) => {
    try {
      return await generalDataService.getAnnouncements();
    } catch (error) {
      return rejectWithValue(returnAxiosOrGeneralFetchError(error));
    }
  },
);
